import { useLingui } from "@lingui/react/macro";
import { TriangleAlert } from "lucide-react";

interface UnitConversionWarningProps {
  /** What the line is measured in. */
  unit: string;
  /** The unit the thing is priced per, which the line's unit has to convert to. */
  pricedUnit: string;
  /** The line is another recipe, so the unit is compared with its yield. */
  isRecipe?: boolean;
}

/**
 * Inline and non-blocking: the line can still be saved, but costing cannot
 * convert between these two units without a pack size or density, and says
 * "cost unavailable" for it. Offering every unit and warning beats hiding the
 * ones that might not cost.
 */
export function UnitConversionWarning({ unit, pricedUnit, isRecipe }: UnitConversionWarningProps) {
  const { t } = useLingui();
  return (
    <p
      role="status"
      className="flex items-start gap-1.5 text-xs text-(--color-warning-text)"
    >
      <TriangleAlert className="mt-0.5 size-3.5 shrink-0" aria-hidden />
      <span>
        {isRecipe
          ? t`"${unit}" may not convert to this recipe's yield unit ("${pricedUnit}"), so the line's cost could be unavailable. Add a yield in a matching unit, or pick a matching unit.`
          : t`"${unit}" may not convert to "${pricedUnit}" without a pack size or density on the ingredient, so the line's cost could be unavailable.`}
      </span>
    </p>
  );
}
